export class Trans {
    private static instance: Trans;

    private constructor() { }

    public static getInstance(): Trans {
        if (!Trans.instance) {
            Trans.instance = new Trans();
        }
        return Trans.instance;
    }
    private translations: { [key: string]: string } = {
    }

    public t(text: string, args?: { [key: string]: any }): string {
        let result = text;
        if (text in this.translations) {
            result = this.translations[text] as string;
            console.log(`Translation for "${text}" found: "${result}"`);
        } else {
            console.warn(`Translation for "${text}" not found`);
        }

        if (args) {
            for (const key in args) {
                if (Object.prototype.hasOwnProperty.call(args, key)) {
                    const value = args[key];
                    result = result.replace(`%${key}`, value);
                }
            }
        }
        return result;
    }
    public set_t(text: string, translation: string): void {
        console.info(`Setting translation for "${text}" to "${translation}"`);
        this.translations[text] = translation;
    }
}
